import Vue from "vue";

export default new Vue({
    data() {
        return {
            events: {
                refresh: {
                    counter: 0,
                },
            },
        }
    },

    methods: {
        watch(component, handler, event) {
            component.$watch(() => {
                return this.events[event];
            }, () => {
                handler(this.events[event].data);
            }, {deep: true});
        },
        emit(event, data) {
            this.events[event].counter++;
            if (data !== undefined) {
                this.events[event].data = data;
            }
        }
    }
});
